import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="container-fluid py-4">
      <div className="alert alert-warning">
        <h1 className="h5">Pagina non trovata o gestionale non aggiornato</h1>
        <p className="mb-2 small">
          Se apri un link nuovo (es. Analisi Easy Retail) e vedi questa schermata, sul server Corevian
          va fatto <strong>git pull</strong> e rebuild del frontend.
        </p>
        <Link to="/dashboard" className="btn btn-sm btn-primary me-2">
          Dashboard
        </Link>
        <Link to="/reports" className="btn btn-sm btn-outline-secondary">
          Report
        </Link>
      </div>
    </div>
  );
}
